import React from 'react'
import 'chart.js/auto';

import { Chart } from "react-google-charts";

function ChartComponent({ type, headerArr, dataArr }) {
    const options = {
          title: 'Company Performance',
          curveType: 'function',
          /* legend: { position: 'bottom' }, */
          
        };
  return (
    <>
        {/* data should be in the form of [[y-axisHeader, x-axisHeader], [x1, y1], [x2, y2].......[xn, yn]] */}
        <Chart
            chartType={type}
            data={[...headerArr, ...dataArr]}
            width="100%"
            height="400px"
        legendToggle
        options={options}
        style={{ background:'red' }}
        
        />
    </>
  )
}

export default ChartComponent